'use client';

import { c as _c } from "react/compiler-runtime";
import type { ProductFeedItem } from '__generated__/api/unauth/types.gen';
import { useSuspenseQuery } from '@tanstack/react-query';
import type { MouseEvent } from 'react';
import { UnauthQueryOptions } from '@/api';
import { DONATION_ROUTES } from '@/constants';
import { openResponsiveDialog } from '@/stores/DrawerStore';
import { DonationBenefitDialogContent } from './DonationBenefitDialogContent';
import { ProductCard } from './ProductCard';
export const ProductFeedSection = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/local-market/product-feeds"]()
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useSuspenseQuery(t0);
  let t1;
  if ($[1] !== data?.context?.items) {
    t1 = data?.context?.items ?? [];
    $[1] = data?.context?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const products = t1;
  if (products.length === 0) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex min-h-[240px] flex-col items-center justify-center gap-12 self-stretch py-48"><p className="text-center font-400 text-Gray-550 typo-body3">준비 중인 상품이 없어요.<br />곧 새로운 상품으로 찾아올게요.</p></div>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const handleHelpQuestion = _temp;
  let t2;
  if ($[4] !== products) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = product_0 => <ProductCard key={product_0.productId} product={product_0} onHelpQuestion={e_0 => handleHelpQuestion(e_0, product_0)} />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = products.map(t3);
    $[4] = products;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="grid grid-cols-2 gap-x-24 gap-y-48 self-stretch mobile-tablet:grid-cols-1 mobile-tablet:gap-48">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(e, product) {
  e.preventDefault();
  e.stopPropagation();
  if (!product.giftProductNumber) {
    return;
  }
  const title = `${product.gov?.govName || "\uC9C0\uC790\uCCB4"}에 기부하면?`;
  openResponsiveDialog({
    component: DonationBenefitDialogContent,
    props: {
      govName: product.gov?.govName,
      hideTitle: true,
      giftDetailHref: DONATION_ROUTES.GIFTS_DETAIL.withSearchParams({
        dynamicPath: {
          productNumber: product.giftProductNumber
        }
      })
    },
    title,
    modalHeader: title,
    drawerType: "bottom",
    drawerNoPadding: false,
    className: {
      drawer: "[&_h2]:text-center [&_h2]:mb-8"
    }
  });
}